import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Package, CheckCircle, XCircle, AlertTriangle, Shield, Key, Monitor } from "lucide-react";

interface AssetStatsCardsProps {
  stats: {
    total: number;
    assigned: number;
    returned: number;
    lost: number;
    damaged: number;
    physical: number;
    digital: number;
    credentials: number;
  };
}

export function AssetStatsCards({ stats }: AssetStatsCardsProps) {
  const cards = [
    {
      title: "إجمالي العهد",
      value: stats.total,
      icon: Package,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
    },
    {
      title: "مسلمة",
      value: stats.assigned,
      icon: CheckCircle,
      color: "text-green-600",
      bgColor: "bg-green-100",
    },
    {
      title: "مُرجعة",
      value: stats.returned,
      icon: Shield,
      color: "text-indigo-600",
      bgColor: "bg-indigo-100",
    },
    {
      title: "مفقودة/تالفة",
      value: stats.lost + stats.damaged,
      icon: AlertTriangle,
      color: "text-red-600",
      bgColor: "bg-red-100",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => (
        <Card key={index}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
            <div className={`p-2 rounded-lg ${card.bgColor}`}>
              <card.icon className={`h-4 w-4 ${card.color}`} />
            </div>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{card.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}